import React, { Component, } from 'react'

import EditTrip from 'components/EditTrip'

class EditTripScene extends Component {
  render() {
    return (
      <div>
        <EditTrip {...this.props} />
      </div>
    )
  }
}

export default EditTripScene



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripScene/EditTripScene/component.js